import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Pages } from "../pages";

export function GlobalNavigationHandler() {
	const navigate = useNavigate();

	useEffect(() => {
		const handler = () => {
			navigate(Pages.DefaultRoute.getUrl(), { replace: true });
		};

		window.addEventListener("auth:maintenanceMode", handler);
		return () => window.removeEventListener("auth:maintenanceMode", handler);
	}, [navigate]);

	return null;
}
